// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__1Da_h","Label":"BuildControl_Label__2zAvw","Less":"BuildControl_Less__298tT","More":"BuildControl_More__3JNLb"};